/*
 *
 * Session constants
 *
 */

export const VERIFY_SESSION = 'app/session/VERIFY_SESSION'
export const VERIFY_SESSION_SUCCESS = 'app/session/VERIFY_SESSION_SUCCESS'
export const VERIFY_SESSION_ERROR = 'app/session/VERIFY_SESSION_ERROR'

export const LOG_IN = 'app/session/LOG_IN'
export const LOG_IN_SUCCESS = 'app/session/LOG_IN_SUCCESS'
export const LOG_IN_ERROR = 'app/session/LOG_IN_ERROR'

export const SIGN_UP = 'app/session/SIGN_UP'
export const SIGN_UP_SUCCESS = 'app/session/SIGN_UP_SUCCESS'
export const SIGN_UP_ERROR = 'app/session/SIGN_UP_ERROR'

export const LOG_OUT = 'app/session/LOG_OUT'
export const LOG_OUT_SUCCESS = 'app/session/LOG_OUT_SUCCESS'
export const LOG_OUT_ERROR = 'app/session/LOG_OUT_ERROR'

export const FORGOT_PASSWORD = 'app/session/FORGOT_PASSWORD'
export const FORGOT_PASSWORD_SUCCESS = 'app/session/FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_ERROR = 'app/session/FORGOT_PASSWORD_ERROR'

export const OTP_APPROVE = 'app/session/OTP_APPROVE'
export const OTP_APPROVE_SUCCESS = 'app/session/OTP_APPROVE_SUCCESS'
export const OTP_APPROVE_ERROR = 'app/session/OTP_APPROVE_ERROR'

export const OTP_SEND = 'app/session/OTP_SEND'
export const OTP_SEND_SUCCESS = 'app/session/OTP_SEND_SUCCESS'
export const OTP_SEND_ERROR = 'app/session/OTP_SEND_ERROR'


export const VALIDATE_OTP = 'app/session/VALIDATE_OTP'
export const VALIDATE_OTP_SUCCESS = 'app/session/VALIDATE_OTP_SUCCESS'
export const VALIDATE_OTP_ERROR = 'app/session/VALIDATE_OTP_ERROR'

export const REWARD_ID_AUTHENTICATION = 'app/session/REWARD_ID_AUTHENTICATION'
export const REWARD_ID_AUTHENTICATION_SUCCESS = 'app/session/REWARD_ID_AUTHENTICATION_SUCCESS'
export const REWARD_ID_AUTHENTICATION_ERROR = 'app/session/REWARD_ID_AUTHENTICATION_ERROR'

export const  RESET_PASSWORD = 'app/session/RESET_PASSWORD'
export const  RESET_PASSWORD_SUCCESS = 'app/session/RESET_PASSWORD_SUCCESS'
export const  RESET_PASSWORD_ERROR= 'app/session/RESET_PASSWORD_ERROR'


export const ROUTER = '@@router/LOCATION_CHANGE'


const constants = {
    VERIFY_SESSION,
    VERIFY_SESSION_SUCCESS,
    VERIFY_SESSION_ERROR,
    REWARD_ID_AUTHENTICATION,
    REWARD_ID_AUTHENTICATION_SUCCESS,
    REWARD_ID_AUTHENTICATION_ERROR,
    LOG_IN,
    LOG_IN_SUCCESS,
    LOG_IN_ERROR,
    SIGN_UP,
    SIGN_UP_SUCCESS,
    SIGN_UP_ERROR,
    LOG_OUT,
    LOG_OUT_SUCCESS,
    LOG_OUT_ERROR,
    FORGOT_PASSWORD,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_ERROR,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_ERROR,

    OTP_APPROVE,
    OTP_APPROVE_SUCCESS,
    OTP_APPROVE_ERROR,
    OTP_SEND,
    OTP_SEND_SUCCESS,
    OTP_SEND_ERROR, 
    VALIDATE_OTP,
    VALIDATE_OTP_SUCCESS,
    VALIDATE_OTP_ERROR
}

export default constants

